export default {
  methods: {
    isOccupiedOutput(isOccupied) {
      return isOccupied ? 'Yes' : 'No';
    },
    roomCountOutput(roomCount) {
      return roomCount || roomCount === 0
        ? roomCount
        : 'n/a';
    },
    squareFootageOutput(squareFootage) {
      return `${Number(squareFootage || 0).toLocaleString()} sqft.`;
    },
    utilitiesOnOutput(utilitiesCollection) {
      const {
        hasGas,
        hasPower,
        hasWater,
        isGasOn,
        isPowerOn,
        isWaterOn,
      } = utilitiesCollection;
      const utilities = [];
      if (hasGas || isGasOn) {
        utilities.push('Gas');
      }
      if (hasPower || isPowerOn) {
        utilities.push('Electricity');
      }
      if (hasWater || isWaterOn) {
        utilities.push('Water');
      }
      return utilities.length > 0
        ? utilities.join(', ')
        : 'n/a';
    },
  },
};
